// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const KeyValuePair = t.struct({
    key: t.String,
    value: t.String
}, {
    name: 'KeyValuePair',
    strict: true
});

export const getDefaultState = () => new KeyValuePair({
    key: '',
    value: ''
});

export default KeyValuePair;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/key-value-pair.js